'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfigValue = getConfigValue;

var _stage = require('./stage.js');

var stage = _interopRequireWildcard(_stage);

var _prod = require('./prod.js');

var prod = _interopRequireWildcard(_prod);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Get the config value depending on the environment
 * @param {string} env - the environment. 'prod' or 'stage'
 * @param {string} key - the field name the caller wants to know the value of
 * @return {Object} the value
 */
function getConfigValue(env, key) {
  var environmentConstants = void 0;

  if (env === 'prod') {
    environmentConstants = prod;
  } else {
    environmentConstants = stage;
  }

  return environmentConstants[key];
}